import {ReportItem} from "./report-item";
import {CurrentVend} from "./current-vend";
import {HistoryItem} from "./history-item";
import {MachineOutage} from "./machine-outage";
import * as _ from "lodash";

export class Report {
    statistics: ReportItem[] = [];
    history: HistoryItem[] = [];
    outages: MachineOutage[] = [];
    currentVends: CurrentVend[] = [];

    static fromJson(dict: any): Report {
        let ret = new Report();
        return ret.fromJson(dict);
    }

    fromJson(dict: any): Report {
    	this.statistics = dict.statistics;
        this.history = dict.history;
        this.outages = MachineOutage.fromJsonArray(dict.outages);
        this.currentVends = CurrentVend.fromJsonArray(dict.currentVends);
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/report.ts